import uuid from 'uuid-random';

import { EmailChangePopup } from 'js/app/components/popups/EmailChangePopup/EmailChangePopup';
import { addPopupAction } from 'js/components/common/PopupManager';

const popupId = uuid();
export const showEmailChangePopup = () => addPopupAction({
    id: popupId,
    component: EmailChangePopup,
    isModal: true
});
